import { useQuery } from '@tanstack/react-query';
import type {
  StockMovementListQuery,
  StockMovementListResponse,
} from '@produzionejb/types';
import { api } from './api-client';

const QK = {
  list: (q: Partial<StockMovementListQuery>) => ['stock-movements', 'list', q] as const,
};

function toQueryString(q: Partial<StockMovementListQuery>): string {
  const params = new URLSearchParams();
  if (q.page) params.set('page', String(q.page));
  if (q.pageSize) params.set('pageSize', String(q.pageSize));
  if (q.periodId) params.set('periodId', q.periodId);
  if (q.direction) params.set('direction', q.direction);
  if (q.lotId) params.set('lotId', q.lotId);
  if (q.productId) params.set('productId', q.productId);
  if (q.documentId) params.set('documentId', q.documentId);
  if (q.occurredAtFrom) params.set('occurredAtFrom', q.occurredAtFrom);
  if (q.occurredAtTo) params.set('occurredAtTo', q.occurredAtTo);
  const s = params.toString();
  return s ? `?${s}` : '';
}

export function useStockMovements(query: Partial<StockMovementListQuery>, enabled = true) {
  return useQuery({
    queryKey: QK.list(query),
    queryFn: () =>
      api<StockMovementListResponse>(`/api/stock-movements${toQueryString(query)}`),
    staleTime: 30_000,
    enabled,
  });
}
